<script lang="ts">
  import { CLASSES, type MatchSummaryUnit } from '@arena/shared';

  let {
    winner,
    units,
    youId,
    onleave,
  }: {
    winner: 0 | 1 | null;
    units: MatchSummaryUnit[];
    youId: string;
    onleave: () => void;
  } = $props();

  const myTeam = $derived(units.find((u) => u.id === youId)?.team ?? 0);
  const most = $derived({
    damage: Math.max(1, ...units.map((u) => u.damage)),
    healing: Math.max(1, ...units.map((u) => u.healing)),
  });
  const title = $derived(
    winner === null ? 'Draw' : winner === myTeam ? 'Victory' : 'Defeat',
  );
</script>

<div class="scoreboard panel">
  <h1 class={title.toLowerCase()}>{title}</h1>
  <table>
    <thead>
      <tr><th>Player</th><th>Damage</th><th>Healing</th><th>Rating</th></tr>
    </thead>
    <tbody>
      {#each units as unit (unit.id)}
        <tr class:friendly={unit.team === myTeam}>
          <td style="color: {CLASSES[unit.classes[0]].color}">
            {#each unit.classes as id (id)}<img
                class="class"
                src="/icons/{id}.webp"
                alt={CLASSES[id].name}
                title={CLASSES[id].name}
              />{/each}
            {unit.name}
          </td>
          {#each ['damage', 'healing'] as const as stat (stat)}
            <td class="stat">
              <div
                class="fill {stat}"
                style:width="{(unit[stat] / most[stat]) * 100}%"
              ></div>
              <span>{unit[stat]}</span>
            </td>
          {/each}
          <td>
            {#if unit.ratingAfter !== undefined && unit.ratingBefore !== undefined}
              {unit.ratingAfter}
              <span
                class:up={unit.ratingAfter >= unit.ratingBefore}
                class:down={unit.ratingAfter < unit.ratingBefore}
              >
                ({unit.ratingAfter >= unit.ratingBefore
                  ? '+'
                  : ''}{unit.ratingAfter - unit.ratingBefore})
              </span>
            {/if}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
  <button onclick={onleave}>Return to lobby</button>
</div>

<style>
  .scoreboard {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 460px;
    text-align: center;
    pointer-events: auto;
  }
  h1 {
    font-size: 40px;
  }
  .victory {
    color: #ffd34a;
  }
  .defeat {
    color: var(--enemy);
  }
  table {
    width: 100%;
    margin: 12px 0;
    border-collapse: collapse;
  }
  th {
    color: var(--muted);
    font-weight: normal;
    font-size: 12px;
  }
  td {
    padding: 4px;
  }
  .class {
    width: 18px;
    height: 18px;
    margin-right: 2px;
    vertical-align: middle;
    border-radius: 3px;
  }
  .stat {
    position: relative;
    min-width: 110px;
  }
  .stat span {
    position: relative;
    text-shadow: 0 1px 2px black;
  }
  .fill {
    position: absolute;
    inset: 3px auto 3px 0;
    opacity: 0.5;
  }
  .fill.damage {
    background: #b98a1c;
  }
  .fill.healing {
    background: #3f8a2a;
  }
  tr.friendly {
    background: rgba(76, 175, 80, 0.12);
  }
  .up {
    color: var(--friendly);
  }
  .down {
    color: var(--enemy);
  }
</style>
